import { useEffect } from "react";
import { GetMachineWiseCostList } from "../../services/ReduxTookit/Slice/WorkFlowRedux";
import { useState } from "react";
import { commonservices, monthMap } from "../../services/CommonServices";
import { useDispatch } from "react-redux";
import cardicon from "../../assets/images/cardicon.svg";
import listicon from "../../assets/images/list.svg";
import { Table } from "react-bootstrap";
import Loader, { LoaderType } from "../common-component/Loader";
import Nodata from "../common-component/Nodata";
import close from "../../assets/images/close.svg";
import StackedBarChart from "../common-component/StackedBarChart";

function MachineWiseCostPopup({
  projectname,
  workflowid,
  showtype,
  handleshowPopup,
}) {
  const dispatch = useDispatch();
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [MachineWiseCostdata, setMachineWiseCostdata] = useState(null);
  const [MachineWiseCostloader, setMachineWiseCostloader] = useState(true);
  const [activeTab, setActiveTab] = useState(1);
  const [YearlyChartReportData, setYearlyChartReportData] = useState({
    labels: [],
    datasets: [],
  });
  const [MTDChartReportData, setMTDChartReportData] = useState({
    labels: [],
    datasets: [],
  });

  const getMachineWiseCostList = async () => {
    // API call to fetch machine wise cost list
    const body = {
      workflowid: workflowid,
      timezone: browserTimezone,
    };
    dispatch(GetMachineWiseCostList(body))
      .then((response) => {
        if (response?.payload?.isValidate) {
          const chartData = {
            labels: response?.payload?.data?.data?.dataList3?.map(x => monthMap[x.monthname]) || [],
            datasets: [
              {
                label: 'Cost',
                data: response?.payload?.data?.data?.dataList3?.map(x => x.consumptioncost) || [],
                backgroundColor: "#53b152",
              }
            ]
          };

          const mtdChartData = {
            labels: response?.payload?.data?.data?.dataList4?.map(x => x.day_no) || [],
            datasets: [
              {
                label: 'Cost',
                data: response?.payload?.data?.data?.dataList4?.map(x => x.totalcost) || [],
                backgroundColor: "#53b152",
              }
            ]
          };
          setYearlyChartReportData(chartData);
          setMTDChartReportData(mtdChartData);
          setMachineWiseCostdata(response?.payload?.data?.data);
          setMachineWiseCostloader(false);
        }
        if (!response?.payload?.isValidate) {
          setMachineWiseCostdata(null);
          setMachineWiseCostloader(true);
        }
      })
      .finally(() => { });
  };

  useEffect(() => {
    if (showtype === "lastrun") {
      setActiveTab(0);
    } else if (showtype === "mtd") {
      setActiveTab(1);
    }

    getMachineWiseCostList();
  }, [workflowid, showtype]);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };


  return (
    <div className="schedular-popup workflow-card-run-mtd-tooltip-popup">
      <div className="popup-title">
        <div className="mtd-lastrun-tab">
          <h2 title={projectname}>{projectname}</h2>
          <div className="custom-tabing tourWorkFlowDashboardTab singledesh-tab">
            <div
              className={activeTab === 0 ? "single-tab active" : "single-tab"}
              onClick={() => handleTabClick(0)}
            >
              <img src={listicon} alt="listicon" />
              <span>Last Run</span>
            </div>
            <div
              className={activeTab === 1 ? "single-tab active" : "single-tab"}
              onClick={() => handleTabClick(1)}
            >
              <img src={cardicon} alt="cardicon" />
              <span>MTD</span>
            </div>
            <div
              className={activeTab === 2 ? "single-tab active" : "single-tab"}
              onClick={() => handleTabClick(2)}
            >
              <img src={listicon} alt="listicon" />
              <span>Last Year</span>
            </div>
          </div>
        </div>
        <img
          src={close}
          alt="close"
          className="cursor-pointer"
          id="scheduler"
          onClick={(e) => {
            handleshowPopup(e);
          }}
        />
      </div>
      <div className="popup-body">
        {activeTab === 0 && (
          <div className="table-wrapper-main">
            <Table responsive>
              <thead>
                <tr>
                  <th>Machine Name</th>
                  <th className="text-center">Total Time</th>
                  <th className="text-end">Cost</th>
                </tr>
              </thead>
              <tbody>
                {MachineWiseCostloader ? (
                  <Loader type={LoaderType.TableRow} count={4} nooftd={3} />
                ) : (
                  <>

                    {
                      MachineWiseCostdata?.dataList1?.length > 0 ? (
                        ["Starter", "Other", "Exit"].map((category) =>
                          MachineWiseCostdata?.dataList1?.filter((itm) =>
                            category === "Other"
                              ? itm?.machinename?.toUpperCase() !==
                              "STARTER" &&
                              itm?.machinename?.toUpperCase() !== "EXIT"
                              : itm?.machinename === category
                          )?.map((item_2, index_2) => {
                            return (
                              <tr key={item_2?.machinename}>
                                <td>
                                  {item_2?.machinename ? item_2?.machinename : ""}
                                </td>
                                <td className="text-center">
                                  {item_2?.totaltime ?
                                    commonservices.calculateDurationSec(
                                      parseInt(item_2?.totaltime)
                                    )
                                    : 0
                                  }
                                </td>
                                <td className="text-end">
                                  $
                                  {item_2?.totalcost
                                    ? commonservices.fnAmountDigitCount(
                                      item_2?.totalcost,
                                      5
                                    )
                                    : 0}
                                </td>
                              </tr>
                            );
                          }))
                      ) : (
                        <>
                          {/* <td colSpan={100}>
                                        {" "}
                                        <Nodata />
                                    </td> */}
                        </>
                      )}
                  </>
                )}
              </tbody>
            </Table>
            {((MachineWiseCostdata &&
              MachineWiseCostdata?.dataList1?.length === 0) ||
              !MachineWiseCostdata) &&
              !MachineWiseCostloader && (
                <>
                  <Table>
                    <tbody>
                      <tr>
                        <td>{!MachineWiseCostloader && <Nodata />}</td>
                      </tr>
                    </tbody>
                  </Table>
                </>
              )}
          </div>
        )}
        {activeTab === 1 && (
          <div className="table-wrapper-main">
            <div className="chart-box">
              {MachineWiseCostloader ? (
                <div className="my-2">
                  <Loader type={LoaderType.ChartLine} />
                </div>
              ) : (
                <div className="dashboard-stacked-chart-main-chart-wrapper">
                  {MTDChartReportData?.datasets?.length > 0 ? (
                    <StackedBarChart data={MTDChartReportData} barthickness={10} />
                  ) : (
                    <div className="d-flex h-100 justify-content-center align-items-center">
                      <Nodata />
                    </div>
                  )}
                </div>
              )}
            </div>
            {/* <h3>MTD Cost</h3> */}
            <div>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Machine Name</th>
                    <th className="text-center">Total Time</th>
                    <th className="text-end">Cost</th>
                  </tr>
                </thead>
                <tbody>
                  {MachineWiseCostloader ? (
                    <Loader type={LoaderType.TableRow} count={4} nooftd={3} />
                  ) : (
                    <>
                      {
                        MachineWiseCostdata?.dataList2?.length > 0 ? (
                          ["Starter", "Other", "Exit"].map((category) =>
                            MachineWiseCostdata?.dataList2?.filter((itm) =>
                              category === "Other"
                                ? itm?.machinename?.toUpperCase() !==
                                "STARTER" &&
                                itm?.machinename?.toUpperCase() !== "EXIT"
                                : itm?.machinename === category
                            )?.map((item_2, index_2) => {
                              return (
                                <tr key={item_2?.machinename}>
                                  <td>
                                    {item_2?.machinename ? item_2?.machinename : ""}
                                  </td>
                                  <td className="text-center">
                                    {item_2?.totaltime ?
                                      commonservices.calculateDurationSec(
                                        parseInt(item_2?.totaltime)
                                      )
                                      : 0
                                    }
                                  </td>
                                  <td className="text-end">
                                    $
                                    {item_2?.totalcost
                                      ? commonservices.fnAmountDigitCount(
                                        item_2?.totalcost,
                                        5
                                      )
                                      : 0}
                                  </td>
                                </tr>
                              );
                            }))
                        ) : (
                          <>
                            {/* <td colSpan={100}>
                                        {" "}
                                        <Nodata />
                                    </td> */}
                          </>
                        )}
                    </>
                  )}
                </tbody>
              </Table>
              {((MachineWiseCostdata &&
                MachineWiseCostdata?.dataList2?.length === 0) ||
                !MachineWiseCostdata) &&
                !MachineWiseCostloader && (
                  <>
                    <Table>
                      <tbody>
                        <tr>
                          <td>{!MachineWiseCostloader && <Nodata />}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </>
                )}
            </div>

          </div>

        )}
        {activeTab === 2 && (
          <div className="table-wrapper-main">
            <div className="chart-box">
              {MachineWiseCostloader ? (
                <div className="my-2">
                  <Loader type={LoaderType.ChartLine} />
                </div>
              ) : (
                <div className="dashboard-stacked-chart-main-chart-wrapper">
                  {YearlyChartReportData?.datasets?.length > 0 ? (
                    <StackedBarChart data={YearlyChartReportData} barthickness={20} />
                  ) : (
                    <div className="d-flex h-100 justify-content-center align-items-center">
                      <Nodata />
                    </div>
                  )}
                </div>
              )}
            </div>
            <div>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Month</th>
                    <th className="text-center">Total Time</th>
                    <th className="text-end">Cost</th>
                  </tr>
                </thead>
                <tbody>
                  {MachineWiseCostloader ? (
                    <Loader type={LoaderType.TableRow} count={4} nooftd={3} />
                  ) : (
                    <>
                      {
                        MachineWiseCostdata?.dataList3?.length > 0 ? (
                          MachineWiseCostdata?.dataList3?.map((item) => {
                            return (
                              <tr key={item?.monthno}>
                                <td>
                                  {item?.monthname ? item?.monthname : ""}
                                </td>
                                <td className="text-center">
                                  {item?.runtime ?
                                    commonservices.calculateDurationSec(
                                      parseInt(item?.runtime)
                                    )
                                    : 0
                                  }
                                </td>
                                <td className="text-end">
                                  $
                                  {item?.consumptioncost
                                    ? commonservices.fnAmountDigitCount(
                                      item?.consumptioncost,
                                      5
                                    )
                                    : 0}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <>
                            {/* <td colSpan={100}>
                                        {" "}
                                        <Nodata />
                                    </td> */}
                          </>
                        )}
                    </>
                  )}
                </tbody>
              </Table>
              {((MachineWiseCostdata &&
                MachineWiseCostdata?.dataList2?.length === 0) ||
                !MachineWiseCostdata) &&
                !MachineWiseCostloader && (
                  <>
                    <Table>
                      <tbody>
                        <tr>
                          <td>{!MachineWiseCostloader && <Nodata />}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </>
                )}
            </div>
            {/* <h3>Last Year Cost Chart</h3> */}


          </div>
        )}
      </div>
    </div>
  );
}

export default MachineWiseCostPopup;
